import { defineNuxtPlugin, useNuxtApp, useRouter } from '#imports'
import { getConfig } from '@b2ag/micro-front-tools'

export default defineNuxtPlugin({
  name: 'sentry',
  enforce: 'pre',
  parallel: true,
  hooks: {
    async 'app:created'() {
      const { initSentry } = await import('@b2ag/sentry')

      const nuxtApp = useNuxtApp()

      initSentry({
        params: {
          app: nuxtApp.vueApp,
          dsn: getConfig('SENTRY_DSN'),
          enabled: getConfig('SENTRY_ENABLED') === 'yes',
          environment: getConfig('ENVIRONMENT_NAME'),
          release: getConfig('VERSION'),
          tracesSampleRate: getConfig('SENTRY_TRACE_SAMPLE_RATE'),
          allowUrls: getConfig('SENTRY_ALLOW_URLS'),
          maxValueLength: 8000,
        },
        router: useRouter(),
      })
    },
  },
})
